// import React, { useEffect, useState } from "react";
// import { useAuthContext } from "../../components/AuthProvider";
// import { loginPayload } from "../../components/entities/auth.payload";
// import { useNavigate } from "react-router-dom";
// import _ from "lodash";
// import { Form, Input, Button, Checkbox, message, Spin } from "antd";
// import { UserOutlined, LockOutlined, EyeOutlined, EyeInvisibleOutlined, WifiOutlined } from "@ant-design/icons";
// import { Link } from 'react-router-dom';

// function Login() {
//   const navigate = useNavigate();
//   const { handleLoginUser } = useAuthContext();
//   const [loading, setLoading] = useState(false);
//   const [isOnline, setIsOnline] = useState(navigator.onLine);
//   const [form] = Form.useForm();

//   useEffect(() => {
//     console.log("Login component mounted, initial online status:", navigator.onLine);

//     // Handle online/offline events
//     const handleOnline = () => {
//       setIsOnline(true);
//       message.success({
//         content: "Internet connection restored.",
//         key: "networkStatus",
//         icon: <WifiOutlined style={{ color: "green" }} />,
//       });
//       console.log("Connection restored");
//     };

//     const handleOffline = () => {
//       setIsOnline(false);
//       message.error({
//         content: "No internet connection. Please check your network and try again.",
//         key: "networkStatus",
//         duration: 0, // Persist until online or manually closed
//         icon: <WifiOutlined style={{ color: "red" }} />,
//       });
//       console.log("Connection lost");
//     };

//     window.addEventListener("online", handleOnline);
//     window.addEventListener("offline", handleOffline);

//     // Check initial offline status
//     if (!navigator.onLine) {
//       handleOffline();
//     }

//     // Cleanup event listeners
//     return () => {
//       window.removeEventListener("online", handleOnline);
//       window.removeEventListener("offline", handleOffline);
//     };
//   }, []);

//   const submitLogin = async (values) => {
//     console.log("submitLogin called with values:", values);

//     if (!isOnline) {
//       console.log("Login attempt blocked: offline");
//       message.error({
//         content: "Cannot login without an internet connection.",
//         key: "loginAttempt",
//         icon: <WifiOutlined style={{ color: "red" }} />,
//       });
//       return;
//     }

//     setLoading(true);
//     console.log("Set loading to true, current state:", loading);

//     // Simulate a 2-second delay to ensure loading state is visible (remove in production)
//     await new Promise(resolve => setTimeout(resolve, 2000));

//     try {
//       console.log("Calling handleLoginUser with:", _.cloneDeep(values));
//       await handleLoginUser(_.cloneDeep(values));
//       console.log("Login successful, navigating to dashboard");
//       // navigate("/dashboard/informational");
//     } catch (error) {
//       console.error("Error during login:", error);
//       message.error(error.response?.data?.error || "Failed to login. Please check your credentials.");
//     } finally {
//       setLoading(false);
//       console.log("Set loading to false, current state:", loading);
//     }
//   };

//   return (
//     <section className="login-content">
//       <div className="row m-0 align-items-center bg-white vh-100">
//         {/* Left Image Section */}
//         <div className="col-md-6 d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
//           <img
//             src="../../assets/images/auth/02.png"
//             className="img-fluid gradient-main animated-scaleX"
//             alt="Login"
//           />
//         </div>

//         {/* Right Login Form Section */}
//         <div className="col-md-6">
//           <div className="row justify-content-center">
//             <div className="col-md-10">
//               <div className="card card-transparent shadow-none d-flex justify-content-center mb-0 auth-card">
//                 <div className="card-body z-3 px-md-0 px-lg-4">
//                   <h2 className="mb-2 text-center">Synergy TOSS</h2>
//                   <p className="text-center">Trading Operational Support System</p>

//                   <Spin spinning={loading} tip="Logging in...">
//                     <Form
//                       form={form}
//                       initialValues={loginPayload()}
//                       onFinish={submitLogin}
//                       layout="vertical"
//                       onFinishFailed={() => {
//                         console.log("Form validation failed");
//                         message.error("Please fill in all required fields.");
//                       }}
//                     >
//                       <Form.Item
//                         name="username"
//                         label="User Name"
//                         rules={[
//                           { required: true, message: "Please enter your username!" },
//                         ]}
//                       >
//                         <Input
//                           prefix={<UserOutlined />}
//                           placeholder="Enter Username"
//                           disabled={loading || !isOnline}
//                         />
//                       </Form.Item>

//                       <Form.Item
//                         name="password"
//                         label="Password"
//                         rules={[
//                           { required: true, message: "Please enter your password!" },
//                         ]}
//                       >
//                         <Input.Password
//                           prefix={<LockOutlined />}
//                           placeholder="Enter Password"
//                           visibilityToggle={{
//                             visible: false,
//                             onVisibleChange: (visible) => {
//                               console.log("Password visibility toggled:", visible);
//                             },
//                           }}
//                           iconRender={(visible) =>
//                             visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
//                           }
//                           disabled={loading || !isOnline}
//                         />
//                       </Form.Item>

//                       <Form.Item>
//                         <div className="d-flex justify-content-between">
//                           <Form.Item name="remember" valuePropName="checked" noStyle>
//                             <Checkbox disabled={loading || !isOnline}>Remember Me</Checkbox>
//                           </Form.Item>
                          
//       <button
//         type="button"
//         onClick={() => navigate("/toss/forgotpassword")}
//         style={{
//           background: "none",
//           border: "none",
//           color: "#007bff",
//           textDecoration: "underline",
//           cursor: "pointer",
//           padding: 0,
//           fontSize: "14px"
//         }}
//       >
//         Forgot Password?
//       </button>
//                         </div>
//                       </Form.Item>

//                       <Form.Item>
//                         <Button
//                           type="primary"
//                           htmlType="submit"
//                           block
//                           loading={loading}
//                           disabled={!isOnline}
//                           style={{
//                             backgroundColor: "blue",
//                             borderColor: "blue",
//                             height: 40,
//                           }}
//                         >
//                           {loading ? "Loading..." : "Login"}
//                         </Button>
//                       </Form.Item>
//                     </Form>
//                   </Spin>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default Login;


import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../components/AuthProvider";
import { loginPayload } from "../../components/entities/auth.payload";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { Form, Input, Button, Checkbox, message, Spin } from "antd";
import { UserOutlined, LockOutlined, EyeOutlined, EyeInvisibleOutlined, WifiOutlined } from "@ant-design/icons";

function Login() {
  const navigate = useNavigate();
  const { handleLoginUser } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [form] = Form.useForm();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      message.success({
        content: "Internet connection restored.",
        key: "networkStatus",
        icon: <WifiOutlined style={{ color: "green" }} />,
      });
    };

    const handleOffline = () => {
      setIsOnline(false);
      message.error({
        content: "No internet connection. Please check your network and try again.",
        key: "networkStatus",
        duration: 0,
        icon: <WifiOutlined style={{ color: "red" }} />,
      });
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const submitLogin = async (values) => {
    if (!isOnline) {
      message.error({
        content: "Cannot login without an internet connection.",
        key: "loginAttempt",
        icon: <WifiOutlined style={{ color: "red" }} />,
      });
      return;
    }

    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 500)); // small delay

    try {
      await handleLoginUser(_.cloneDeep(values));
      // ❌ DO NOT NAVIGATE HERE – AuthProvider will redirect based on roles
    } catch (error) {
      message.error(error.response?.data?.error || "Failed to login. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="login-content">
      <div className="row m-0 align-items-center bg-white vh-100">
        <div className="col-md-6 d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
          <img
            src="../../assets/images/auth/02.png"
            className="img-fluid gradient-main animated-scaleX"
            alt="Login"
          />
        </div>

        <div className="col-md-6">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="card card-transparent shadow-none d-flex justify-content-center mb-0 auth-card">
                <div className="card-body z-3 px-md-0 px-lg-4">
                  <h2 className="mb-2 text-center">Synergy TOSS</h2>
                  <p className="text-center">Trading Operational Support System</p>

                  <Spin spinning={loading} tip="Logging in...">
                    <Form
                      form={form}
                      initialValues={loginPayload()}
                      onFinish={submitLogin}
                      layout="vertical"
                      onFinishFailed={() => {
                        message.error("Please fill in all required fields.");
                      }}
                    >
                      <Form.Item
                        name="username"
                        label="User Name"
                        rules={[{ required: true, message: "Please enter your username!" }]}
                      >
                        <Input
                          prefix={<UserOutlined />}
                          placeholder="Enter Username"
                          disabled={loading || !isOnline}
                        />
                      </Form.Item>

                      <Form.Item
                        name="password"
                        label="Password"
                        rules={[{ required: true, message: "Please enter your password!" }]}
                      >
                        <Input.Password
                          prefix={<LockOutlined />}
                          placeholder="Enter Password"
                          iconRender={(visible) =>
                            visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                          }
                          disabled={loading || !isOnline}
                        />
                      </Form.Item>

                      <Form.Item>
                        <div className="d-flex justify-content-between">
                          <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox disabled={loading || !isOnline}>Remember Me</Checkbox>
                          </Form.Item>
                          
                          <button
                            type="button"
                            onClick={() => navigate("/toss/forgotpassword")}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#007bff",
                              textDecoration: "underline",
                              cursor: "pointer",
                              padding: 0,
                              fontSize: "14px"
                            }}
                          >
                            Forgot Password?
                          </button>
                        </div>
                      </Form.Item>

                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          loading={loading}
                          disabled={!isOnline}
                          style={{
                            backgroundColor: "blue",
                            borderColor: "blue",
                            height: 40,
                          }}
                        >
                          {loading ? "Loading..." : "Login"}
                        </Button>
                      </Form.Item>
                    </Form>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;